import React, { useEffect, useState } from "react";

// Simple CSS-only confetti burst - runs once, no external deps.
export default function Confetti({ pieces = 60, duration = 3500 }) {
  const [items] = useState(() =>
    Array.from({ length: pieces }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.6,
      dur: 1.8 + Math.random() * 1.6,
      rot: Math.random() * 360,
      color: ["#F59E0B", "#10B981", "#3B82F6", "#EF4444", "#8B5CF6", "#EC4899", "#0F172A"][i % 7],
      w: 6 + Math.floor(Math.random() * 6),
      h: 10 + Math.floor(Math.random() * 8),
    }))
  );
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(t);
  }, [duration]);
  if (!visible) return null;
  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden" aria-hidden>
      {items.map((it) => (
        <span
          key={it.id}
          style={{
            position: "absolute",
            left: `${it.left}%`,
            top: "-20px",
            width: it.w,
            height: it.h,
            background: it.color,
            borderRadius: 2,
            transform: `rotate(${it.rot}deg)`,
            animation: `confettiFall ${it.dur}s cubic-bezier(0.25,0.1,0.35,1) ${it.delay}s forwards`,
          }}
        />
      ))}
      <style>{`
        @keyframes confettiFall {
          to { transform: translateY(105vh) rotate(720deg); opacity: 0.9; }
        }
      `}</style>
    </div>
  );
}
